import { CursorPaginatedResponseSchema, DefaultCursorPageSchema } from 'notable-common';
import { z } from 'zod';
export const ReferenceTableSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    organizationId: z
        .uuid()
        .nullable()
        .describe('The owning organization, or null for a global table shared by every organization.'),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    deleted: z.null().describe('Always null: deleted tables are never returned.'),
});
export const ReferenceTableIdParamsSchema = z.object({ referenceTableId: z.uuid() }).strict();
export const ReferenceTableListQuerySchema = z
    .object({
    q: z
        .string()
        .min(1)
        .max(200)
        .optional()
        .describe('Return only tables whose name contains this text.'),
    // An empty array would serialize to no parameter at all, and so ask for every organization.
    organizationIds: z
        .union([z.uuid(), z.array(z.uuid()).min(1)])
        .optional()
        .describe('Return only tables owned by these organizations.'),
    page: DefaultCursorPageSchema,
})
    .strict();
export const ReferenceTableListResponseSchema = CursorPaginatedResponseSchema(ReferenceTableSchema);
export const ReferenceTableSummarySchema = z.object({
    referenceTable: ReferenceTableSchema,
    columnNames: z.array(z.string()),
    rowCount: z.number().int().nonnegative(),
});
export const ReferenceTableRowSchema = z
    .record(z.string(), z.union([z.string(), z.boolean(), z.number(), z.null()]))
    .describe('One row, keyed by the table column names.');
export const ReferenceTableRowsQuerySchema = z.object({ page: DefaultCursorPageSchema }).strict();
export const ReferenceTableRowsResponseSchema = CursorPaginatedResponseSchema(ReferenceTableRowSchema);
//# sourceMappingURL=read.js.map